export const _getGroupPermissionForm = (state, action) => action.payload;

export const _setGroupPermissions = (state, action) => {
  state.permissions = action.payload;
};
